import logo from "../../assets/images/learningportal.svg";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLoginMutation } from "../../redux/features/auth/authAPI";
import usePageTitle from "../../utils/usePageTitle";
import Error from "../../components/Error";

export default function AdminLogin() {
  usePageTitle("Admin Login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const [login, { data, isLoading, error: responseError }] = useLoginMutation();

  useEffect(() => {
    window.localStorage.clear();
    if (responseError?.data) {
      setError(responseError.data);
    }
    if (data?.accessToken && data?.user) {
      navigate("/admin/dashboard");
    }
  }, [data, navigate, responseError]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (email !== "admin@learnwithsumit.com") {
      setError("Use student portal for student login");
      setEmail("");
      setPassword("");
    } else {
      login({ email, password });
    }
  };

  return (
    <section style={{ paddingTop: "12%" }}>
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <Link to="/admin/login">
            <img className="h-12 mx-auto" src={logo} alt="logo" />
          </Link>
          <h2 className="mt-6 text-center text-4xl text-slate-100">
            Sign in to Admin Account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={(e) => handleSubmit(e)}>
          {/* <input type="hidden" name="remember" value="true" /> */}
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autocomplete="email"
                required
                className="login-input rounded-t-md"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>

              <input
                id="password"
                name="password"
                type="password"
                autocomplete="current-password"
                required
                className="login-input rounded-b-md"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          {/* <div className="flex items-center justify-end">
            <div className="text-sm">
              <button className="font-medium text-violet-600 hover:text-violet-500">
                Forgot your password?
              </button>
            </div>
          </div> */}
          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            >
              Login
            </button>
          </div>
          {error && <Error message={error} />}
        </form>
      </div>
    </section>
  );
}
